import React from 'react'
import { Check, Circle } from 'lucide-react'

const BarraProgreso = ({ ciclo, estadoPestanas }) => {
  const fases = [
    { key: 'planificar', label: 'Planificar', porcentaje: 25 },
    { key: 'hacer', label: 'Hacer', porcentaje: 50 },
    { key: 'verificar', label: 'Verificar', porcentaje: 75 },
    { key: 'actuar', label: 'Actuar', porcentaje: 100 }
  ]

  const progreso = ciclo?.progreso_porcentaje || 0

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-800">
          Progreso del Ciclo
        </h3>
        <span className="text-2xl font-bold text-blue-600">
          {progreso}%
        </span>
      </div>

      {/* Progress bar */}
      <div className="relative">
        <div className="w-full bg-gray-200 rounded-full h-4 mb-6">
          <div 
            className="bg-gradient-to-r from-blue-500 to-green-500 h-4 rounded-full transition-all duration-500"
            style={{ width: `${progreso}%` }}
          ></div>
        </div>

        {/* Phase markers */}
        <div className="flex justify-between relative -mt-3">
          {fases.map((fase, index) => {
            const estado = estadoPestanas?.[fase.key]
            const isCompleted = estado?.completada
            const isActive = estado?.activa
            
            return (
              <div key={fase.key} className="flex flex-col items-center">
                <div className={`
                  w-8 h-8 rounded-full flex items-center justify-center
                  transition-all duration-300
                  ${isCompleted 
                    ? 'bg-green-500 text-white' 
                    : isActive 
                      ? 'bg-blue-500 text-white animate-pulse' 
                      : 'bg-gray-300 text-gray-600'
                  }
                `}>
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    <Circle className="w-4 h-4" fill="currentColor" />
                  )}
                </div>
                <span className={`
                  text-xs mt-2 font-medium
                  ${isActive ? 'text-blue-600' : 'text-gray-600'}
                `}>
                  {fase.label}
                </span>
              </div>
            )
          })}
        </div>
      </div>

      {/* Current phase indicator */}
      {ciclo && (
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-gray-700">
            <span className="font-semibold">Fase actual:</span>{' '}
            <span className="text-blue-600 capitalize">
              {ciclo.fase_actual === 'completado' ? 'Completado' : ciclo.fase_actual}
            </span>
          </p>
          {ciclo.fecha_inicio && (
            <p className="text-xs text-gray-600 mt-1">
              Iniciado: {new Date(ciclo.fecha_inicio).toLocaleDateString()}
            </p>
          )}
        </div>
      )}
    </div>
  )
}

export default BarraProgreso
